/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Alert, InputGroup, Button,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import BaseGrid from '../Common/BaseGrid';
import { post, get } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function SupplierItemForm(props) {
  const { entity, t } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [itemSearch, setItemSearch] = useState(false);
  const [data, setData] = useState(entity);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const toLinkedItemSummary = (item) => {
    if (!item) {
      return null;
    }

    return {
      id: item.id,
      manufacturer: item.manufacturer,
      part_number: item.part_number,
      sku: item.sku,
    };
  };

  useEffect(() => {
    const fetchData = async (id) => {
      try {
        setLoading(true);
        const item = await get(`${url.GET_SUPPLIER_ITEM}/${id}`);

        setData(item);
      } catch (e) {
        setErrorMessage(e.message);
      } finally {
        setLoading(false);
      }
    };

    if (entity.id !== undefined) {
      fetchData(entity.id);
    }
  }, [entity]);

  const save = async (values) => {
    try {
      setLoading(true);
      const payload = {
        id: values.id,
        supplier_sku: values.supplier_sku,
        stock_id: values.stock_id,
        lead_time: values.lead_time,
        suppliers_id: values.suppliers_id,
        notes: values.notes,
        price: values.price,
        moq: values.moq,
        items_id: values.linked_item?.id || null,
      };
      const result = await post(url.POST_SUPPLIER_ITEM, payload);
      setErrorMessage(null);

      toastr.success(`Entity ID ${result.id} saved`, 'Success');
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    supplier_sku: Yup
      .string()
      .required(props.t('Supplier sku is required')),
    stock_id: Yup.string().nullable(),
    notes: Yup
      .string().nullable(),
    linked_item: Yup
      .object()
      .shape({
        id: Yup.number(),
        sku: Yup.string(),
      })
      .nullable(),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={data}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="SupplierItemForm" autoComplete="off">
            <div className="row mt-4 mb-4">
              <Label
                for="supplier_sku"
                className="col-sm-3 col-form-label"
              >
                {props.t('Supplier Sku')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.supplier_sku && touched.supplier_sku ? 'is-invalid' : '')}`}
                  id="supplier_sku"
                  name="supplier_sku"
                />
                <ErrorMessage
                  name="supplier_sku"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="stock_id"
                className="col-sm-3 col-form-label"
              >
                {props.t('Stock ID')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.stock_id && touched.stock_id ? 'is-invalid' : '')}`}
                  id="stock_id"
                  name="stock_id"
                />
                <ErrorMessage
                  name="stock_id"
                  component="div"
                  className="invalid-feedback"
                />
                <small className="text-muted mt-1">
                  {t('Used for printing labels')}
                </small>
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="lead_time"
                className="col-sm-3 col-form-label"
              >
                {props.t('Lead Time')}
              </Label>
              <Col sm={4}>
                <InputGroup>
                  <Field
                    type="number"
                    step="1"
                    min="1"
                    className={`form-control ${(errors.lead_time && touched.lead_time ? 'is-invalid' : '')}`}
                    id="lead_time"
                    name="lead_time"
                  />
                  <span className="input-group-text">{t('days')}</span>
                </InputGroup>
                <ErrorMessage
                  name="lead_time"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="moq"
                className="col-sm-3 col-form-label"
              >
                {props.t('MOQ')}
              </Label>
              <Col sm={6}>
                <InputGroup>
                  <Field
                    type="number"
                    step="1"
                    min="1"
                    className={`form-control ${(errors.moq && touched.moq ? 'is-invalid' : '')}`}
                    id="moq"
                    name="moq"
                  />
                  <span className="input-group-text">{t('X')}</span>
                </InputGroup>
                <ErrorMessage
                  name="moq"
                  component="div"
                  className="text-danger"
                />
                <small className="text-muted mt-1">
                  {t('Minimum Order Quantity')}
                </small>
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="price"
                className="col-sm-3 col-form-label"
              >
                {props.t('Base Price')}
              </Label>
              <Col sm={6}>
                <InputGroup>
                  <span className="input-group-text">{t('$')}</span>
                  <Field
                    type="number"
                    step=".01"
                    min=".01"
                    className={`form-control ${(errors.price && touched.price ? 'is-invalid' : '')}`}
                    id="price"
                    name="price"
                  />
                </InputGroup>
                <ErrorMessage
                  name="price"
                  component="div"
                  className="text-danger"
                />
                <small className="text-muted mt-1">
                  {t('Price per unit')}
                </small>
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="linked_item"
                className="col-sm-3 col-form-label"
              >
                {props.t('Linked Item')}
              </Label>
              <Col sm={8}>
                {(values.linked_item === null || values.linked_item === undefined) && (
                  <InputGroup>
                    <input
                      className="form-control"
                      id="linked_item"
                      readOnly
                      value={loading === true ? props.t('Loading...') : t('None')}
                    />
                    <Button color="warning" onClick={() => { setFieldValue('linked_item', null); setItemSearch(!itemSearch); }}>
                      <span className="mdi mdi-nfc-search-variant" />
                    </Button>
                  </InputGroup>
                )}
                {values.linked_item !== null && values.linked_item !== undefined && (
                  <InputGroup>
                    <input
                      className="form-control"
                      id="linked_item"
                      readOnly
                      value={loading === true ? props.t('Loading...') : `${values.linked_item !== undefined ? `${values.linked_item.manufacturer} ${values.linked_item.part_number}` : ''}`}
                    />
                    <Button color="danger" className="btn btn-dark" onClick={() => { setFieldValue('linked_item', null); }}>
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  </InputGroup>
                )}
                <small className="text-muted mt-1">
                  {t('Our local item linked to this supplier item')}
                </small>
              </Col>
            </div>

            {values.linked_item === null && itemSearch === true && (
              <BaseGrid
                url={url.GET_ITEMS}
                hasSearch
                config={
                {
                  columns: {
                    thumb: {
                      label: '',
                      image: {
                        src: (item) => (`/api/items/thumbnail/${item.id}`),
                        class: 'rounded',
                        style: { maxHeight: '5rem', maxWidth: '5rem' },
                      },
                      translate: false,
                    },
                    id: { label: props.t('ID'), sort: true },
                    part_number: { label: props.t('PN'), sort: true },
                    tags: {
                      label: 'Tags',
                      format: (x) => (x.map((r) => (r.label))),
                      badges: {
                        class: 'bg-info bg-soft text-dark p-2',
                      },
                    },
                    actions: {
                      label: props.t('Actions'),
                      actions: [
                        {
                          key: 'edit',
                          icon: 'mdi mdi-check-bold',
                          class: 'btn btn btn-soft-dark',
                          alt: props.t('Select'),
                          click: (item) => {
                            setFieldValue('linked_item', toLinkedItemSummary(item));
                          },
                        },
                      ],
                    },
                  },
                  pagination: {
                    sort: 'id',
                    direction: 'desc',
                    perPage: 4,
                  },
                }
                }
              />
            )}

            <div className="row mt-4 mb-4">
              <Label
                for="notes"
                className="col-sm-3 col-form-label"
              >
                {props.t('Notes')}
              </Label>
              <Col sm={9}>
                <Field
                  as="textarea"
                  className={`form-control ${(errors.notes && touched.notes ? 'is-invalid' : '')}`}
                  id="notes"
                  name="notes"
                />
                <ErrorMessage
                  name="notes"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

SupplierItemForm.defaultProps = {
  entity: {
    supplier_sku: '',
    notes: '',
  },
  onSuccess: () => {},
};

SupplierItemForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(SupplierItemForm));
